import tawaLogo from "../../assets/images/tawa-logo.png";

export const PLATFORM_LOGO_URL = tawaLogo;

/** Logo da empresa na UI; usa Tawa quando a empresa não enviou `logoImageUrl`. */
export function resolveCompanyLogoUrl(url?: string | null): string {
  return url?.trim() ? url : PLATFORM_LOGO_URL;
}
